import React from "react";
// import "react-big-calendar/lib/css/react-big-calendar.css";
import "./App.scss";
import AuthController from "./navigators/AuthController";

import { setupInterceptors } from "./utilities/axios/axios-setup";
import { Toaster } from "sonner";
import dayjs from "dayjs";
import "dayjs/locale/fr";

dayjs.locale("fr");

setupInterceptors();

function App() {
  return (
    <div className="main-app">
      <AuthController />
      <Toaster position="top-right" expand={true} richColors closeButton />
    </div>
  );
}

export default App;
